(function () {
  function init() {
    if (window.matchMedia('(max-width: 768px)').matches) return;

    var collection = document.querySelector('[data-section-type="collection-template"]');
    var stickyBar = document.querySelector('.collection__sticky-bar');
    var filtersContainer = document.querySelector('.collection__filters');
    if (!collection || !stickyBar || !filtersContainer) return;
    if (document.querySelector('.yuzefi-filter-trigger')) return;

    // Move the filters container to be a child of the sticky bar
    // so the floating panel can anchor to it via position:absolute
    stickyBar.appendChild(filtersContainer);

    // Inject Filter button (sits before Sort by in the bar)
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'yuzefi-filter-trigger';
    trigger.innerHTML = 'Filter <span aria-hidden="true">+</span>';

    var sortBar = stickyBar.querySelector('.collection__sort-bar');
    if (sortBar) {
      stickyBar.insertBefore(trigger, sortBar);
    } else {
      stickyBar.appendChild(trigger);
    }

    function open() {
      collection.classList.add('yuzefi-panel-open');
      trigger.innerHTML = 'Filter <span aria-hidden="true">−</span>';
    }
    function close() {
      collection.classList.remove('yuzefi-panel-open');
      trigger.innerHTML = 'Filter <span aria-hidden="true">+</span>';
    }
    function toggle() {
      if (collection.classList.contains('yuzefi-panel-open')) close();
      else open();
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      toggle();
    });

    // Click outside the panel to close
    document.addEventListener('click', function (e) {
      if (!collection.classList.contains('yuzefi-panel-open')) return;
      if (filtersContainer.contains(e.target)) return;
      if (trigger.contains(e.target)) return;
      close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();